var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    class: _vm.className,
    attrs: { src: _vm.glyph, width: _vm.width, height: _vm.height },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/Icon.vue